import { ApolloLink } from '@apollo/client';
import { scalarsLink } from '@upheal/shared/utils/apollo/link-scalars';
import { errorLink } from '@upheal/shared/utils/apollo/link-error';
import { retryLink } from '@upheal/shared/utils/apollo/link-retry';
import { requestDurationLink } from '@upheal/shared/utils/apollo/link-request-duration';
import { headersLink } from '@upheal/shared/utils/apollo/link-headers';
import { logLink } from '@upheal/shared/utils/apollo/link-log';
import { httpLink } from '@upheal/shared/utils/apollo/link-http';

export const link = ApolloLink.from([
    scalarsLink,
    errorLink,
    retryLink,
    requestDurationLink,
    headersLink,
    logLink,
    httpLink,
]);
